class Progress {
  constructor (canvasId, type, ctx, paramsObj) {
    this.canvasId = canvasId
    this.type = type
    this.ctx = ctx
    this.paramsObj = paramsObj
  }
  scoreCircle () {
    const {circleX, circleY, radius, lineWidth} = this.paramsObj
    this.ctx.beginPath()
    this.ctx.moveTo(circleX + radius, circleY)
    this.ctx.lineWidth = lineWidth
    this.ctx.strokeStyle = '#ebf0f3'
    this.ctx.arc(circleX, circleY, radius, Math.PI * 0, Math.PI * 2)
    this.ctx.closePath()
    this.ctx.stroke()
  }
  scoreSector (startAngle, endAngle, anti) {
    const {circleX, circleY, radius, lineWidth} = this.paramsObj
    this.ctx.beginPath()
    this.ctx.moveTo(circleX, circleY - radius)
    this.ctx.lineWidth = lineWidth
    this.ctx.strokeStyle = '#64c8c8'
    this.ctx.lineCap = 'round'
    this.ctx.arc(circleX, circleY, radius, startAngle * (Math.PI / 180) - (Math.PI / 2), endAngle * (Math.PI / 180) - (Math.PI / 2), anti)
    this.ctx.stroke()
  }
  scoreLoading (timer) {
    const {circleX, circleY, radius, percent} = this.paramsObj
    if (this.paramsObj.process >= percent) {
      clearInterval(timer)
    }

    this.ctx.clearRect(0, 0, circleX * 2, circleY * 2)

    switch (this.type) {
      case 'score':
        this.ctx.font = '34.13333333vw PingFang SC'
        this.ctx.textAlign = 'center'
        this.ctx.textBaseline = 'middle'
        this.ctx.filleStyle = '#000'
        this.ctx.fillText(parseFloat(this.paramsObj.process).toFixed(0), circleX, circleY)

        this.ctx.font = '11.2vw PingFang SC'
        this.ctx.textAlign = 'center'
        this.ctx.textBaseline = 'top'
        this.ctx.fillStyle = '#000'
        this.ctx.fillText('分', circleX + 105, circleY - 60)
        break
      case 'load':
        this.ctx.font = '6vw PingFang SC'
        this.ctx.textAlign = 'center'
        this.ctx.textBaseline = 'middle'
        this.ctx.filleStyle = '#648c8c8'
        this.ctx.fillText('正在分析黑头数量...', circleX, circleY)
        break
      default:break
    }

    this.scoreCircle(circleX, circleY - radius, radius)
    this.scoreSector(0, this.paramsObj.process / 100 * 360)

    switch (true) {
      case (this.paramsObj.process / percent > 0.9):
        this.paramsObj.process += 0.3
        break
      case (this.paramsObj.process / percent > 0.8):
        this.paramsObj.process += 0.5
        break
      case (this.paramsObj.process / percent > 0.7):
        this.paramsObj.process += 0.7
        break
      default:
        this.paramsObj.process += 1
        break
    }
  }
}

export default Progress



// WEBPACK FOOTER //
// ./src/lib/progressbar.js